import { invoiceActionStatus } from "@/lib/utils";
import { setInvoiceDueDate, setVendors } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useGetExpenseIncomePerformance } from "@/services";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useFinancialOversight = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: expenseIncomeData, isLoading: isExpenseIncomeDataLoading } =
    useGetExpenseIncomePerformance({
      communityId: communityDetail?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityDetail?.communityId && currentFinanceYear),
      },
    });

  const onOverdueClick = () => {
    dispatch(setVendors(null));
    dispatch(setInvoiceDueDate("overdue"));
    navigate(`${routes.invoice}/${invoiceActionStatus.posted}`);
  };

  const onDueClick = () => {
    dispatch(setVendors(null));
    dispatch(setInvoiceDueDate("7_days_due"));
    navigate(`${routes.invoice}/${invoiceActionStatus.posted}`);
  };

  const onIncomePerformanceClick = () => {
    dispatch(setInvoiceDueDate("30_+"));
    navigate(routes.billingHistory);
  };

  return {
    expenseIncomeData,
    isExpenseIncomeDataLoading,
    onOverdueClick,
    onDueClick,
    onIncomePerformanceClick,
  };
};

export default useFinancialOversight;
